import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, CUSTOM_ELEMENTS_SCHEMA, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { UtilService } from 'src/app/services/util.service';
import { CandidateCardTableViewComponent } from '../../job-module/candidate-card-table-view/candidate-card-table-view.component';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CandidateCardComponent } from '../../cards/candidate-card/candidate-card.component';
// Direct import. NewJobComponent transitively imports this component, so
// the import cycle is broken with `forwardRef(() => NewJobComponent)` in
// the @Component imports array — TS-level compilation would otherwise
// resolve one side of the cycle to undefined at module-load time.
import { NewJobComponent } from 'src/app/page/homepage/layout-jobs/new-job/new-job.component';
import Swal from 'sweetalert2';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { APP_ICONS } from 'src/app/icons/icon-provider';


import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-suggested-candidates-ai-list',
  standalone: true,
  imports: [CommonModule, InfiniteScrollModule,
CandidateCardTableViewComponent, CommonSkeletonComponent, CandidateCardComponent, FormsModule,
    NgIconComponent,
    forwardRef(() => NewJobComponent),
  ],
  providers: [provideIcons(APP_ICONS)],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './suggested-candidates-ai-list.component.html',
  styleUrls: ['./suggested-candidates-ai-list.component.scss']
})
export class SuggestedCandidatesAiListComponent implements OnInit,OnChanges,OnDestroy {
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.talent-pool-container')),
  });


  @Input() jobDetails:any;
  @Input() designVersion: string = 'v2';

  /** Draft jobs never get AI matches (the fetch is blocked below), so the
   *  Marketplace Candidates empty state says why instead of "will appear here". */
  get isDraftJob(): boolean {
    const status = this.jobDetails?.status?.toUpperCase();
    return status === 'DRAFT' || status === 'DRAFTED';
  }
  @Output() parentValueChange = new EventEmitter<any>();

  userType: any = localStorage.getItem('userType');
  userId: any;
  url = AppSettings.photoUrl;

  // Data properties
  response: any = [];
  pageNumber: number = 0;
  stopscrollFlag: boolean = false;
  loadAPIcall: boolean = false;
  responseReceived: boolean = false;

  // Filter & Search
  searchText: string = '';
  searchExpanded: boolean = true;
  selectedStage: any;
  activeFiltersCount: number = 0;

  // Subscriptions
  private subscriptions: Subscription[] = [];

  @ViewChild('jobsupplytemplate') jobSupplyTemplate: TemplateRef<any>;

  constructor(private apiService: ApiService, private util: UtilService,
    private router: Router,private candidateService: CandidateService, 
    private modalService : NgbModal,private planService : PricePlanService, private bsModalService: BsModalService){

  }
  ngOnInit(): void {

    this.scrollGate.attach();
    this.checkCeipalFreePlan();
    this.userId = localStorage.getItem('userId');
    this.subscriptions.push(this.scrollSubject.pipe(
      debounceTime(100)
    ).subscribe(() => {
      if (this.loadAPIcall || this.stopscrollFlag || !this.responseReceived) return;
      this.getListOfCandidates();
    }));
    // Initial fetch is owned by ngOnChanges (fires before ngOnInit when
    // `jobDetails` is bound at creation). Calling getListOfCandidates() here
    // too produced two parallel requests to the AI-retry endpoint; one
    // reliably hit the error path on the 2nd mount (returning from Talent
    // Pool) and flipped stopscrollFlag=true, killing infinite scroll.
  }

  private checkCeipalFreePlan(): void {
    const membershipType = localStorage.getItem('MemberShipType');
    if (this.jobDetails?.source === 'CEIPAL' && membershipType === 'Free') {
      Swal.fire({
        icon: 'info',
        title: '',
        text: 'AI features are not available for CEIPAL Free plan. Please upgrade your plan to access AI-powered recommendations.',
        showConfirmButton: true,
        confirmButtonText: 'OK'
      });
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobDetails?.currentValue) {
      this.jobDetails = changes.jobDetails.currentValue;
      this.fetchGeneration++;
      this.pageNumber = 0;
      this.response = [];
      // Reset the rendered list too — getListOfCandidates() appends into
      // candidatesList with dedup by candidateId, so leaving stale items here
      // made a tab re-click look like the reload never happened.
      this.candidatesList = [];
      this.marketplaceTotalCount = 0;
      this.topMatchScore = 0;
      this.viaRecruitersCount = 0;
      this.stopscrollFlag = false;
      this.payload.searchAfterKey = null;
      
      // Initialize loading state for API call
      this.responseReceived = false;
      this.loadAPIcall = true;
      
      if (this.jobDetails?.status === 'DRAFT') {
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      this.responseReceived = true;
      this.stopscrollFlag = true; // also blocks any accidental scroll fetch
      return;
    }
      this.getListOfCandidates();
    }
  }
  ngOnDestroy(): void {

    this.scrollGate.detach();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  payload = {
    jobId : '',
    limit : 10,
    groupType : 'SUGGESTED_CANDIDATE',
    searchContent : this.searchText,
    searchAfterKey : null
  }

  candidatesList:any[] = [];
  // Marketplace Candidates ("Available candidates" stat) — total count from the
  // findTopSuggestedCandidates response (data.totalCount).
  marketplaceTotalCount: number = 0;
  // "Top Match" stat — highest match score in the result set (data.maxScore,
  // a percentage). "Via Recruiters" stat — freelance recruiter network count
  // (data.freelanceRecruiterCount). Both come from findTopSuggestedCandidates.
  topMatchScore: number = 0;
  viaRecruitersCount: number = 0;
  // Stale-response gate: bumped on every list reset (ngOnChanges / search).
  // A fetch captures the value at launch; if a reset happens while it's in
  // flight, the late response is discarded so it can't append old-page rows
  // or overwrite payload.searchAfterKey for the new fetch cycle.
  private fetchGeneration: number = 0;
  getListOfCandidates(){
    // Prevent API call for Draft status jobs
    const jobStatus = this.jobDetails?.status?.toUpperCase();
    console.log('[suggested-candidates-ai-list getListOfCandidates] jobStatus:', jobStatus, 'jobDetails.status:', this.jobDetails?.status);
    
    if (jobStatus === 'DRAFT' || jobStatus === 'DRAFTED') {
      console.log('[suggested-candidates-ai-list getListOfCandidates] Blocking API call for Draft job');
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      this.responseReceived = true;
      this.stopscrollFlag = true;
      return;
    }
    console.log('[suggested-candidates-ai-list getListOfCandidates] Proceeding with API call');
    
    this.payload.jobId = this.jobDetails.jobId;
    this.responseReceived = false; // Set to false to show "AI is analyzing" message
    this.loadAPIcall = true; // Set to true to show loading state
    const requestGeneration = this.fetchGeneration;
    // First page only (searchAfterKey null before paging starts). The three
    // summary tiles describe the whole query, and later scroll pages carry a
    // lower per-page maxScore — capturing only on the first page keeps them stable.
    const isFirstPage = this.payload.searchAfterKey === null;

    // Use retry mechanism: 3 retries with 25s delay = ~75s total
    this.apiService.suggestionsWithRetry('candidates/findTopSuggestedCandidates', this.payload).subscribe({
      next: (res) => {
        if (requestGeneration !== this.fetchGeneration) {
          return; // response belongs to a fetch cycle that was reset — drop it
        }
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.responseReceived = true;
        if(res.code == '00000'){
          const newCandidates = res.data.candidateList || [];
          if (isFirstPage) {
            this.marketplaceTotalCount = res.data.totalCount ?? 0;
            this.topMatchScore = Number(res.data.maxScore) || 0;
            this.viaRecruitersCount = res.data.freelanceRecruiterCount ?? 0;
          }
          this.payload.searchAfterKey = res.data.searchAfterKey || null;

          // Process new candidates
          newCandidates.forEach((a) => {
            a.status = 'ACTIVE';
            a.availability = true;
          });

          // Append new candidates to existing list and remove duplicates
          const combinedCandidates = [...this.candidatesList, ...newCandidates];
          const uniqueCandidatesMap = new Map(combinedCandidates.map(candidate => [candidate.candidateId, candidate]));
          this.candidatesList = Array.from(uniqueCandidatesMap.values());

          // Check if we should stop scrolling
          if (newCandidates.length < 10 || !this.payload.searchAfterKey) {
            this.stopscrollFlag = true;
          }
        }
      },
      error: (err) => {
        console.error('[suggested candidates] API Error:', err);
        if (requestGeneration !== this.fetchGeneration) {
          return; // stale cycle — don't touch the new fetch's loading state
        }
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.responseReceived = true;
        // Don't flip stopscrollFlag on error — a transient failure (AI still
        // processing, network blip) shouldn't permanently disable infinite
        // scroll. The success path is the only place that can declare "no
        // more pages" (line 141: <10 items or no searchAfterKey).

        // Handle processing timeout (after max retries exhausted)
        if (err.timeout && err.isProcessing) {
          // Swal.fire({
          //   title: 'Analysis In Progress',
          //   text: err.message || 'The AI is analyzing candidates. This may take a moment. Please try again shortly.',
          //   icon: 'warning',
          //   confirmButtonText: 'OK'
          // });
          console.error('Failed to fetch suggested candidates:', err);
        } else {
          // Other errors - silent handling, just log
          console.error('Failed to fetch suggested candidates:', err);
        }
      }
    });
  }

  toggleSearch() {
    // this.searchExpanded = !this.searchExpanded;
    if (this.searchExpanded) {
      setTimeout(() => {
        const searchInput = document.getElementById('talent_pool_search') as HTMLInputElement;
        if (searchInput) {
          searchInput.focus();
        }
      }, 300);
    }
  }

  onSearchFocus() {
    this.searchExpanded = true;
  }

  onSearchBlur() {
    if (!this.searchText || this.searchText.trim() === '') {
      setTimeout(() => {
        // this.searchExpanded = false;
      }, 200);
    }
  }

  /** Search trigger — mirrors the pattern used in talent-pool and
   *  job-applicants: reset paging + list, then re-fetch so the backend
   *  filters by the new `searchText`. */
  filterCandidates(): void {
    // Prevent API call for Draft status jobs
    const jobStatus = this.jobDetails?.status?.toUpperCase();
    console.log('[suggested-candidates-ai-list filterCandidates] jobStatus:', jobStatus, 'jobDetails.status:', this.jobDetails?.status);
    
    if (jobStatus === 'DRAFT' || jobStatus === 'DRAFTED') {
      console.log('[suggested-candidates-ai-list filterCandidates] Blocking API call for Draft job');
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      this.responseReceived = true;
      this.stopscrollFlag = true;
      return;
    }
    console.log('[suggested-candidates-ai-list filterCandidates] Proceeding with API call');
    
    this.fetchGeneration++;
    this.pageNumber = 0;
    this.candidatesList = [];
    this.stopscrollFlag = false;
    this.responseReceived = false; // Set to false to show "AI is analyzing" message
    this.loadAPIcall = true; // Set to true to show loading state
    // Restart paging from page 1 — searching while scrolled deep would
    // otherwise send the old cursor and return mid-list results.
    this.payload.searchAfterKey = null;
    this.getListOfCandidates();
  }
  trackByCandidateId(index: number, item: any): any {
  return item.candidateId;
}

  // Infinite scroll
  // onScrollDown() {
  //   if (!this.stopscrollFlag) {
  //     setTimeout(() => {
  //       this.loadAPIcall = true;
  //       this.getListOfCandidates();
  //     }, 200);
  //   }
  // }
  scrollSubject = new Subject<void>();
  onScrollDown() {
    // Prevent API call for Draft status jobs
    const jobStatus = this.jobDetails?.status?.toUpperCase();
    if (jobStatus === 'DRAFT' || jobStatus === 'DRAFTED') {
      return;
    }

    if (!this.stopscrollFlag && !this.loadAPIcall && this.responseReceived && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }

  // Action handlers
  route(candidate: any) {
    this.router.navigate(['newcandidates'], {
      queryParams: { candidateId: candidate.candidateId, tabName: 'profileSummary' }
    });
  }

  open(candidate: any) {
    this.util.startLoader();
    this.candidateService.updateCandidateViewed(candidate).subscribe(
      res => {
        this.util.stopLoader();
      },
      err => {
        this.util.stopLoader();
      }
    );
  }

  // Intentional no-op — the child `app-candidate-card-table-view` owns
  // the resume-download flow end-to-end (plan-check via
  // ACTIVE_INTERACTIONS, then registered blob download via
  // `candidates/resumeDownload/...`). The previous body here opened
  // `this.url + fileId` directly, bypassing plan-gating entirely. See
  // candidate-card-table-view.component.ts:416-466 for the correct
  // flow. Leave body empty — child handles everything.
  downloadResume(candidate: any): void {
    // No-op on purpose. See comment above.
  }

  sendMessage(candidate: any) {
    // Implement messaging logic
    console.log('Send message to:', candidate);
  }

  openDocuments(candidate: any) {
    // Implement documents logic
    console.log('Open documents for:', candidate);
  }

  shareProfile(candidate: any) {
    // Implement share logic
    console.log('Share profile:', candidate);
  }

  scheduleInterview(candidate: any) {
    // Implement interview scheduling
    console.log('Schedule interview with:', candidate);
  }

  addNotes(candidate: any) {
    // Implement notes functionality
    console.log('Add notes for:', candidate);
  }

  updateStatus(status: any, candidate: any) {
    // Implement status update
    console.log('Update status:', status, candidate);
  }

  updatetocandidateActivity(event: any) {
    this.parentValueChange.emit(event);
  }

  reasons: any[] = [];
  candidateScore:any;
  private retryAttempt: number = 0;

  showDetails(item:any, modal:any){
    console.log('item: ', item);
    let payload = {
      sourceEntityId : this.jobDetails.jobId,
      targetEntityId : item.candidateId,
      type : 'JOB',
      groupType : 'APPLICANT_JOB'
    }
    // Don't use util.startLoader() - it blocks entire app during AI processing
    this.reasons = [];
    this.candidateScore = null;
    this.retryAttempt = 0;

    // Use default retry settings: 3 retries with 25s delay = ~75s total
    this.apiService.fetchRankingDetailsWithRetry(payload).subscribe({
      next: (res) => {
        if(res.code == '00000'){
          // Handle both old format (ranking) and new format (rankings array)
          let ranking = null;

          if (res.data.ranking) {
            // Old format: single ranking object
            ranking = res.data.ranking;
          } else if (res.data.rankings && res.data.rankings.length > 0) {
            // New format: rankings array
            const firstRanking = res.data.rankings[0];
            if (firstRanking.targetEntities && firstRanking.targetEntities.length > 0) {
              const targetEntity = firstRanking.targetEntities[0];
              // Merge ranking data with targetEntity data
              ranking = {
                ...firstRanking,
                targetEntityId: targetEntity.targetEntityId,
                score: targetEntity.score,
                reason: targetEntity.reason || firstRanking.reason,
                strengths: targetEntity.strengths || firstRanking.strengths || [],
                weaknesses: targetEntity.weaknesses || firstRanking.weaknesses || [],
                updatedOn: targetEntity.updatedOn || firstRanking.updatedOn
              };
            }
          }

          if(ranking){
            // Build reasons array from the ranking object
            this.reasons = [{
              targetEntityId: ranking.targetEntityId,
              score: ranking.score,
              reason: ranking.reason,
              strengths: ranking.strengths || [],
              weaknesses: ranking.weaknesses || [],
              updatedOn: ranking.updatedOn
            }];

            this.candidateScore = ranking.score + '%';
            this.openModal(modal);
          }else {
            Swal.fire('No ranking details available','','info');
          }
        }else {
          Swal.fire('Something went wrong','','error');
        }
      },
      error: (err) => {

        // Handle processing timeout
        if (err.timeout && err.isProcessing) {
          Swal.fire({
            title: 'Analysis In Progress',
            text: err.message || 'The AI analysis is taking longer than expected. Please try again in a moment.',
            icon: 'warning',
            confirmButtonText: 'OK'
          });
        } else if (err.isProcessing) {
          // Retry in progress - show loading message
          this.retryAttempt++;
          Swal.fire({
            title: 'Analyzing Match...',
            html: `AI is analyzing candidate compatibility.<br><small>Attempt ${this.retryAttempt}/3</small>`,
            icon: 'info',
            timer: 2500,
            timerProgressBar: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        } else {
          // Other errors
          Swal.fire('Something went wrong','','error');
        }
      }
    });
  }

  openModal(modalName: any){
    try {
      this.modalService.open(modalName, {size: 'md', centered: true}).result.then((result) => {
        console.log('Modal closed with result:', result);
      }, (reason) => {
        console.log('Modal dismissed with reason:', reason);
      });
    } catch (error) {
      console.error('Error opening modal:', error);
      Swal.fire('Error', 'Failed to open modal', 'error');
    }
  }

  closeModal(){
    this.modalService.dismissAll();
  }

  closeJobSupplyModal() {
      if (this.candidateSupplyRef) {
        this.candidateSupplyRef.hide();
      }
    }
  
    isClicked: boolean = false;
    candidateData: any;
    focus: string;
    invite(values: any) {
      console.log('invite button clicked', values);
  
      if (this.isClicked) {
        return;
      }
  
      this.util.startLoader();
      this.isClicked = true;
      this.candidateData = values;
      this.focus = 'candidate';
  
      // this.checkConnectionStatus(values)
      //   .subscribe(response => {
          //if (values.isFeatured == true) {
            this.proceedToInvite(values, this.jobSupplyTemplate);
         // } else if (values.isFeatured == false || values.isFeatured == null) {
            // if (response.data.connectionStatus === 'CONNECTED') {
            //   this.proceedToInvite(values, this.jobSupplyTemplate);
            // } else if (response.data.connectionStatus !== 'CONNECTED') {
            //   this.proceedToInvite(values, this.jobSupplyTemplate);
              // to be used later
              // this.openConnectionTemplate(response.data.connectionStatus, values, connectionModal);
            //}
        //  }
        //})
        setTimeout(() => {
          this.isClicked = false;
        }, 5000);
    }
  
      candidateSupplyRef: BsModalRef;
      
      async proceedToInvite(values, jobsupplytemplate) {
          this.util.startLoader();
          const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
          let {membershipType } = userData;
          if (userData.isExpired) {
            this.util.stopLoader();
            let availablePoints = null;
            let actualPoints = null;
            let utilizedPoints = null;
            let promotional = null;
            userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
              if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
                this.util.stopLoader();
                availablePoints = ele.available
                actualPoints = ele.actual
                utilizedPoints = ele.utilized
                promotional = ele.promotional
              }
            })
            let popupType: "PAY" | "LIMIT"   | "UPGRADE" = "PAY";
      
            if (['Starter','Growth','ScaleX'].includes(membershipType)) {
              popupType = "LIMIT";
            }
            this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);
      
            return;
          }
          values.userId = localStorage.getItem('userId');
          values.candidatefilter = true;
          values.getResume = false;
          values.userType = values.user ? values.user.userType : null;
          const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
          this.candidateSupplyRef = this.bsModalService.show(jobsupplytemplate, config);
          this.util.stopLoader();
        }

  // Helper method to set rank on candidate object for row-design view
  setRankAndShowSkills(item: any, rank: number): any {
    // Modify the item in place to avoid creating new object references
    if (item.showAllSkills === undefined) {
      item.showAllSkills = false;
    }
    item.rank = rank;
    return item;
  }

  // AI Processing message logic - copied from candidate-card-table-view
  get noResultMessage(): string {
    if (!this.responseReceived) {
      return 'Our AI is analyzing this job and finding the best matching candidates for you...';
    } else {
      return 'No marketplace candidates available yet. Our AI is processing this job posting to find perfect matches. Please check back soon!';
    }
  }

  get noResultSvgType(): string {
    // Always show AI processing icon for AI-powered suggested candidates
    return 'customAiProcessing';
  }
}
